.ux-iws-stateful-filter-button {
    display: inline-flex;
    align-items: center;
    position: relative;
    padding: 5px 0 3px;

    button {
        background: none;
        color: inherit;
        border: unset;
        border-radius: unset;
        padding: 0;
        cursor: pointer;
    }

    ux-badge {
        background: $color-blue-1;
        position: absolute;
        top: 0;
        left: 0;
    }

    ux-icon {
        margin-right: 7px;
    }
}
